export type AccountsView = 'table' | 'map' | 'heatmap'

const ACCOUNTS_LAST_VIEW_KEY = 'supplyco:accountsLastView'

export function parseAccountsView(value: unknown): AccountsView {
  return value === 'map' || value === 'table' || value === 'heatmap' ? value : 'table'
}

export function getAccountsLastView(): AccountsView {
  if (globalThis.window === undefined) {
    return 'table'
  }

  try {
    return parseAccountsView(globalThis.localStorage.getItem(ACCOUNTS_LAST_VIEW_KEY))
  }
  catch {
    return 'table'
  }
}

export function setAccountsLastView(view: AccountsView): void {
  if (globalThis.window === undefined) {
    return
  }

  try {
    globalThis.localStorage.setItem(ACCOUNTS_LAST_VIEW_KEY, view)
  }
  catch {
    // ignore storage failures (private mode, quota, etc.)
  }
}
